import { works } from "@/mocks/works";
import { news } from "@/mocks/news";

const searchPool = [
  ...works.map((w) => ({ label: w.title, type: "影视作品", path: `/works/${w.id}` })),
  ...news.map((n) => ({ label: n.title, type: "资讯动态", path: `/news/${n.id}` })),
];

export function getSuggestions(keyword: string) {
  const kw = keyword.trim().toLowerCase();
  if (!kw) return [];
  return searchPool.filter((item) => item.label.toLowerCase().includes(kw)).slice(0, 6);
}

export function searchWorks(keyword: string) {
  const kw = keyword.trim().toLowerCase();
  if (!kw) return works;
  return works.filter((w) => {
    const hitTag = w.tags.some((t) => t.toLowerCase().includes(kw));
    const hitCast = w.cast.some((c) => c.toLowerCase().includes(kw));
    return (
      w.title.toLowerCase().includes(kw) ||
      w.role.toLowerCase().includes(kw) ||
      w.director.toLowerCase().includes(kw) ||
      hitCast ||
      hitTag
    );
  });
}

export function searchNews(keyword: string) {
  const kw = keyword.trim().toLowerCase();
  if (!kw) return news;
  return news.filter(
    (n) =>
      n.title.toLowerCase().includes(kw) ||
      n.summary.toLowerCase().includes(kw) ||
      n.category.toLowerCase().includes(kw),
  );
}